// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"19fcde60","689":"f4a8a2af","787":"51f3a3da","876":"94a9a872"}[chunkId] + ".chunk.js";
};